import { useTheme } from '@material-ui/core';

import { defaultChartColors, getChartColors } from '../../theme/colors';

export const useColors = () => {
  const { palette } = useTheme();

  // Returns the chart color hex for a given key and theme mode (stable across contexts)
  const getChartColorForKey = (key: string): string => {
    let hash = 0;

    // Use a stable hash function to ensure the same index is used for the same key
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }

    const colorIndex = Math.abs(hash) % defaultChartColors.length;
    const colorName = defaultChartColors[colorIndex];
    const colorHexCode = getChartColors(palette.type)[colorName];

    return colorHexCode;
  };

  return { getChartColorForKey };
};
